import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';

export class Helper {

	constructor() {
	
	}
	
	// echex flash message
	public static echexFlashMessage(flashMessagesService, message, type){
		// success 
		if(type == 'success'){
			flashMessagesService.show(message, { cssClass: 'alert-success',timeout:60000, showCloseBtn:false  });
		}
		// error
		if(type == 'error'){
			flashMessagesService.show(message, { cssClass: 'alert-danger', timeout:60000, showCloseBtn:false  });
		}
    }

	
	// Check object is empty or not
	public static isEmpty(obj) {
		for(var key in obj) {
		  if(obj.hasOwnProperty(key))
			return false;
		}
		return true;
   }


}


// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/helpers/helper.ts